import Box from '@mui/material/Box';
import { useAuth } from '../../context/AuthContext';
import { IMPERSONATION_BANNER_HEIGHT } from './ImpersonationBanner';

interface ContentAreaProps {
  children: React.ReactNode;
}

export function ContentArea({ children }: ContentAreaProps) {
  const { isImpersonating } = useAuth();
  const topOffset = 64 + (isImpersonating ? IMPERSONATION_BANNER_HEIGHT : 0);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        mt: `${topOffset}px`,
        p: { xs: 2, sm: 3, md: 4 },
        minHeight: `calc(100vh - ${topOffset}px)`,
        overflow: 'auto',
        transition: 'margin-top 150ms ease',
      }}
    >
      {children}
    </Box>
  );
}
